export default __webpack_public_path__ + "static/Arvore-7029a60ca86de9c3d25db1e2cf065765.png";